import React from 'react';

import { Outlet } from 'react-router-dom';

import Header from '@components/Header';
import Navbar from '@components/Navbar';
import RequireAuth from '@components/RequireAuth';

import styles from './style.module.scss';

const Layout: React.FC = () => {
  return (
    <RequireAuth>
      <>
        <header>
          <Header />
        </header>
        <div className={styles.container}>
          <Navbar />
          <main>
            <div className={styles.content}>
              <Outlet />
            </div>
          </main>
        </div>
      </>
    </RequireAuth>
  );
};

export default Layout;
